import React, { FC, useEffect } from 'react';
import styled, { css } from 'src/theme';
import {Col, Row, Card, Popover} from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';

import { usePresenter } from './usePresenter';

import {
  profileImg,
  hintLamonterra,
  hintMontekristo,
  hintMonterossa,
  hintTramontana,
  hintMP20,
  hintS21,
} from 'src/assets/images';

interface Props {}

export const Step3: FC<Props> = () => {
  const presenter = usePresenter();

  useEffect(() => {}, [presenter.selectedMetalTile, presenter.selectedPailing])

  const productProfiles = {
    metalTileType: [
      {
        id: 1,
        displayName: 'Ламонтерра',
        name: 'Ламонтерра',//
        img: profileImg,
        description1: 'Высота профиля',
        description2: '14 мм',
        hint: {
          image: hintLamonterra,
          text: 'Профиль Ламонтерра\u00AE обладает всеми достоинствами классической керамической черепицы, но при этом отличается доступной стоимостью. Его рельеф выполнен в виде плавных, набегающих волн. Кровля из такого материала выглядит изящно и элегантно.',
        },
      },
      {
        id: 5,
        displayName: 'Монтекристо',
        name: 'Монтекристо',//
        img: profileImg,
        description1: 'Высота ступени',
        description2: '25/30/35 мм',
        hint: {
          image: hintMontekristo,
          text: 'Прямые и плавные линии Монтекристо\u00AE впишутся в любой архитектурный стиль. Как и у других профилей нового поколения, у Монтекристо\u00AE есть несколько типоразмеров ступенек. Это позволит выбрать подходящую конфигурацию материала, добавить крыше оригинальность.',
        },
      },
      {
        id: 6,
        displayName: 'Монтерроса',
        name: 'Монтерроса',//
        img: profileImg,
        description1: 'Высота ступени',
        description2: '25/30/35 мм',
        hint: {
          image: hintMonterossa,
          text: 'Профиль отличается выразительным, S-образным рельефом и оснащён фигурным 3-D резом. Он придаёт кровле дополнительный объём и делает горизонтальные стыки незаметными. Двойные капиллярные канавки на боковых краях обеспечивают 100% герметичность стыков.',
        },
      },
      {
        id: 7,
        displayName: 'Трамонтана',
        name: 'Трамонтана',//
        img: profileImg,
        description1: 'Высота ступени',
        description2: '25/30/35 мм',
        hint: {
          image: hintTramontana,
          text: 'Рельеф профиля Трамонтана\u00AE напоминает горные хребты. Кровля из такого материала оригинально выглядит и устойчива к сильному ветру. 3-D рез придаёт кровле дополнительный объём, а двойные капиллярные канавки защищают стыки листов от влаги.',
        },
      },
    ],
    pailingType: [
      {
        id: 1,
        displayName: 'МП-20',
        name: 'МП20',
        img: profileImg,
        description1: 'Высота профиля',
        description2: '18 мм',
        hint: {
          image: hintMP20,
          text: 'Профнастил МП-20 (R) создан для кровель частных домов. Его боковые кромки образуют полноценный боковой нахлёст, благодаря чему в соединения не попадает влага. А капиллярная канавка отводит конденсат и обеспечивает дополнительную герметичность стыков.',
        },
      },
      {
        id: 2,
        displayName: 'С-21',
        name: 'С21',
        img: profileImg,
        description1: 'Высота профиля',
        description2: '21 мм',
        hint: {
          image: hintS21,
          text: 'Рельеф профнастила С-21 (A) выполнен в виде аккуратных симметричных гофр. Они придают материалу хорошую несущую способность и привлекательный вид. Боковые края С-21 (A) стыкуются в верхней части волны и образуют герметичные соединения.',
        },
      },
    ]
  };

  const handleClickMetalTile = (name: string) => {
    presenter.setMetalTileID(name);
  }

  const handleClickPailing = (name: string) => {
    presenter.setPailingID(name);
  }

  const renderCard = (product: typeof productProfiles.metalTileType[0], onClick: () => void, isActive: boolean) => (
    <CardWrapper>
      <CardStyled
        onClick={onClick}
        $active={isActive}
        cover={ <img alt={product.displayName} src={product.img} /> }
      >
        <Card.Meta
          title={product.displayName}
          description={ <>{product.description1}<br />{product.description2}</> }
        />
      </CardStyled>
      {product.hint && (
        <HintIcon onClick={(e) => e.stopPropagation()}>
          <Popover
            content={
              <HintContent>
                <img src={product.hint.image} alt={product.displayName} />
                <p>{product.hint.text}</p>
              </HintContent>
            }
            trigger="hover"
            placement="right"
          >
            <InfoCircleOutlined />
          </Popover>
        </HintIcon>
      )}
    </CardWrapper>
  );

  return (
    <RowStyled>
      <Col xs={23}>

        <Row justify={'space-around'} style={{ marginBottom: '10px' }}>
          <Col>
            <ButtonStyled onClick={() => presenter.setMetalProfile('Металлочерепица')} $active={presenter.metalProfile === 'Металлочерепица'}>Металлочерепица</ButtonStyled>
          </Col>

          <Col>
            <ButtonStyled onClick={() => presenter.setMetalProfile('Профнастил')} $active={presenter.metalProfile === 'Профнастил'}>Профнастил</ButtonStyled>
          </Col>
        </Row>

        {presenter.metalProfile === 'Металлочерепица' &&
          <Row gutter={[{ xs: 8, lg: 16 }, { xs: 8, lg: 16 }]}>
            {
              productProfiles.metalTileType.map(product => (
                  <Col xs={8} lg={6} key={product.id}>
                    {renderCard(
                      product,
                      () => handleClickMetalTile(product.name),
                      product.name === presenter.selectedMetalTile
                    )}
                  </Col>
              ))
            }
          </Row>
        }

        {presenter.metalProfile === 'Профнастил' &&
          <Row gutter={[{ xs: 8, lg: 16 }, { xs: 8, lg: 16 }]} style={{ textAlign: 'center' }}>
            {
              productProfiles.pailingType.map(product => (
                <Col xs={8} lg={6} key={product.id}>
                  {renderCard(
                    product,
                    () => handleClickPailing(product.name),
                    product.name === presenter.selectedPailing
                  )}
                </Col>
              ))
            }
          </Row>
        }

      </Col>
    </RowStyled>
  );
};

const CardWrapper = styled.div`
  position: relative;
`;

const CardStyled = styled(Card)<{ $active: boolean }>`
  ${(props) => css`
    color: ${props.theme.colors.nero};
    border-radius: 4px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
    border: 1px solid ${props.$active ? `${props.theme.colors.orange};` : '#FFF'};
    & .ant-card-cover {
      padding: 7px 14px;
    }
    & .ant-card-body {
      padding: 0 14px 14px;
    }
    & .ant-card-meta-title {
      margin: 0 !important;
      font-family: Montserrat, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: -0.05em;
    }
    & .ant-card-meta-description {
      font-family: PT Root UI, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 100%;
      letter-spacing: -0.035em;
      color: ${props.theme.colors.nero};
    }
    @media screen and ${props.theme.media.mobile} {
      & .ant-card-cover {
        padding: 5px;
      }
      & .ant-card-body {
        padding: 0 5px 5px;
      }
    }
  `}
`;

const HintIcon = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 10;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.35);
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;

const HintContent = styled.div`
  max-width: 280px;
  img {
    width: 100%;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.75);
  }
`;

const ButtonStyled = styled.button<{ $active: boolean }>`
  ${(props) => css`
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    margin-bottom: 15px;
    color: ${props.$active ? props.theme.colors.orange : props.theme.colors.nero};
    @media screen and ${props.theme.media.tablet} {}
  `}
`;

const RowStyled = styled(Row)`
  display: flex;
  justify-content: center;
  min-height: 276px;
  text-align: center;
  padding: 25px 10px;
  background: ${props => props.theme.colors.smoke};
  border-radius: 6px;
  @media screen and ${props => props.theme.media.mobile} {
    padding: 25px 0;
  }
`;
